import 'alpinejs'
import IMask from 'imask';
import * as FilePond from 'filepond';

window.$ = window.jQuery = require('jquery');
window.Swal = require('sweetalert2');
window.toastr = require("toastr");
window.moment = require("moment");
window.IMask = IMask;
window.googleMap = require("./vendor/googlemaps/jquery.googlemap");
window.FilePond = FilePond;

window.datepicker = require('bootstrap-datepicker');
require('bootstrap-datepicker/dist/locales/bootstrap-datepicker.sk.min.js');

require('./bootstrap')

// CoreUI
require('@coreui/coreui-pro');
window.Utils = require("@coreui/utils");

// Boilerplate
require('./plugins');
